import { BellIcon } from "@chakra-ui/icons";
import {
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DeleteUserModal from "./DeleteUserModal";
import UpdateRoleModal from "./UpdateRoleModal";

const backendURL = "https:/3.6.130.138.nip.io/v1";

const AdminPanel = () => {
  // useEffect(() => {
  //   document.title = "Admin Panel";
  // }, []);
  const toast = useToast({
    position: "right-bottom",
    duration: 3000,
    isClosable: true,
  });

  const { user, token } = useSelector((state) => state.auth);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedUser, setSelectedUser] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const getUsersFromDB = async () => {
    // console.log("token", token);
    setLoading(true);
    const response = await fetch(`https:/3.6.130.138.nip.io/v1/user/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
        // "x-access-token": token,
      },
    });
    const data = await response.json();
    setUsers(data);
  };

  const handleDelete = async (user_id) => {
    // delete user
    //https:/3.6.130.138.nip.io/v1/user/
    // const repsonse = prompt("type yes to delete this user?");
    await fetch(`https:/3.6.130.138.nip.io/v1/user/?id=${user_id.$oid}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
        // "x-access-token": token,
      },
    });
    toast({
      title: "User Deleted",
      status: "success",
    });
    setIsDeleteOpen(false);

    // update users
    getUsersFromDB();
  };

  // patch request to update role
  const handleUpdate = async (_id, role) => {
    await fetch(`https:/3.6.130.138.nip.io/v1/user/role/${_id.$oid}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
        // "x-access-token": token,
      },
      body: JSON.stringify({ role }),
    });

    setIsOpen(false);
    getUsersFromDB();
    toast({ description: "Role updated successfully", status: "success" });
  };

  useEffect(() => {
    getUsersFromDB();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (users.length > 0) {
      setLoading(false);
    }
  }, [users]);

  //   if (user.role !== "admin") return <Box>Not Authorized</Box>;

  return (
    <Flex
      alignItems="center"
      flexDir="column"
      my="5"
      // h="85vh"
      w="100%"
      gap="10"
    >
      <Heading textAlign="center" w="100%" fontSize="30px" pl="1rem">
        Admin Panel
      </Heading>
      {selectedUser && isOpen && (
        <UpdateRoleModal
          user={selectedUser}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          handleUpdate={handleUpdate}
        />
      )}

      {selectedUser && isDeleteOpen && (
        <DeleteUserModal
          user={selectedUser}
          handleDelete={handleDelete}
          isOpen={isDeleteOpen}
          setIsOpen={setIsDeleteOpen}
        />
      )}

      {/* show all user's data in table once loaded */}

      {loading ? (
        <Box>Loading...</Box>
      ) : (
        <TableContainer w="100%">
          <Table variant="striped" colorScheme="facebook">
            <Thead>
              <Tr>
                <Th textAlign="center">Name</Th>
                <Th textAlign="center">Email</Th>
                <Th textAlign="center">Role</Th>
                <Th textAlign="center">Operation</Th>
                <Th textAlign="center">Requests</Th>
              </Tr>
            </Thead>
            <Tbody overflowX="hidden" overflowY="scroll">
              {users.map((currentUser) => (
                <Tr key={`Tr` + currentUser._id.$oid}>
                  <Td textAlign="center">{currentUser.name}</Td>
                  <Td textAlign="center">{currentUser.email}</Td>
                  <Td textAlign="center" textTransform="capitalize">
                    {currentUser.role}
                  </Td>
                  <Td>
                    <Flex justifyContent="center" gap="2" alignItems="center">
                      <Button
                        colorScheme="orange"
                        isDisabled={currentUser._id.$oid === user._id}
                        onClick={() => {
                          // open update role modal
                          setSelectedUser(currentUser);
                          setIsOpen(true);
                        }}
                      >
                        Modify Role
                      </Button>
                      <Button
                        isDisabled={currentUser._id.$oid === user._id}
                        colorScheme="red"
                        onClick={() => {
                          setSelectedUser(currentUser);
                          setIsDeleteOpen(true);
                        }}
                      >
                        Delete
                      </Button>
                    </Flex>
                  </Td>
                  <Td>
                    {/* show alert icon on request */}
                    <Flex justifyContent="center" alignItems="center">
                      {/* show 1 number on top of bell icon */}
                      <Box position="relative">
                        {currentUser.upgrade_request && (
                          <Badge
                            position="absolute"
                            top="-1"
                            right="0"
                            zIndex="100"
                            colorScheme="red"
                            borderRadius="md"
                          >
                            1
                          </Badge>
                        )}
                        <IconButton
                          colorScheme={
                            currentUser.upgrade_request ? "red" : "gray"
                          }
                          onClick={() => {
                            setSelectedUser(currentUser);
                            setIsOpen(true);
                          }}
                          isDisabled={
                            !currentUser.upgrade_request ||
                            currentUser._id.$oid === user._id
                          }
                          icon={<BellIcon />}
                        />
                      </Box>
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </Flex>
  );
};

export default AdminPanel;
